import { Box } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

/** 툴바 36px + 본문 최소 높이 360px (public/css/lexical_editor.scss) — 에디터가 뜰 때 높이가 튀지 않게 맞춤 */
const EditorSkeleton = () => (
  <Box
    aria-hidden
    sx={{
      border: '1px solid var(--dk-line, rgba(231, 233, 236, 1))',
      borderRadius: '8px',
    }}
  >
    <Box
      sx={{
        height: 36,
        px: 1,
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid var(--dk-line, rgba(231, 233, 236, 1))',
      }}
    >
      <Skeleton variant="rect" width={240} height={18} />
    </Box>
    <Box sx={{ height: 360 }} />
  </Box>
);

export default EditorSkeleton;
